import { Component } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { authorValidator } from './role-selected.directive';
import { AuthorsService } from '../authors.service';
import { Author } from '../author';
import { LoadingService } from 'src/app/loading.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-new-author',
  templateUrl: './new-author.component.html',
  styleUrls: ['./new-author.component.css']
})
export class NewAuthorComponent {
  
  constructor(private formBuilder: FormBuilder, private authorsService: AuthorsService, private loadingService: LoadingService) {}

  selectedFile?: File = undefined
  fileName = '';

  authorForm = this.formBuilder.group({
    firstName: [''],
    lastName: [''],
    bio: [''],
  }, {validators: authorValidator})

  onSubmit() {
    const newAuthor = ({uid: undefined, firstName: this.authorForm.value.firstName, lastName: this.authorForm.value.lastName, bio: this.authorForm.value.bio }) as Author
    const loadingKey = newAuthor.lastName
    this.loadingService.addLoadingKey(loadingKey)
    this.authorsService.addNewAuthor(newAuthor, loadingKey, this.selectedFile)
  }

  cancelClicked() {
    this.authorsService.addUserCancelled()
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.fileName = file.name;
        this.selectedFile = file
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.selectedFile = undefined
    this.fileName = ""
  }
}
